import { CurrentLocation32 } from '@vinted/monochrome-icons'
import { Icon } from '@vinted/web-ui'

type Props = {
  lat: number
  lng: number
}

// google-map-react is using lat and lng internally
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const CurrentLocation = ({ lat, lng }: Props) => (
  <div className="pickup-point-map__current-location">
    <Icon
      name={CurrentLocation32}
      color="primary-default"
      aria={{
        'aria-hidden': 'true',
      }}
      testId="current-location"
    />
  </div>
)

export default CurrentLocation
